<template>
  <!-- <card :header-text="'Raw Data '+ company.companyname"> -->
  <div>
    <div class="row mb5 mt15">
      <div class="col-md-5"></div>
      <div class="col-md-3">
        <span v-for="(d, index) in duration" v-bind:key="d.id+d.name">
          <button
            type="button"
            @click="getDurationData(index)"
            class="btn btn-sm mb5"
            :class="(d.active)? 'btn-primary': 'btn-outline-secondary'"
            style="padding: 0.2rem;"
          >{{d.name}}</button>
        </span>
      </div>
    </div>
    <div class="row mb5">
      <div class="col-md-10" :id="type+'comPriceChartContent'">
        <canvas :id="type+'comprice'"></canvas>
      </div>
      <!-- <div class="col-md-10" v-else>v-if="comPriceData.length>0"
          <div class="alert alert-danger" role="alert">No data to plot graph!</div>
      </div>-->
    </div>

    <div class="row mt15">
      <div class="col-md-4"></div>
      <div class="col-md-1"></div>
      <div class="col-md-1">
         <download :tableId="company.companyname+'-'+type" :fileName="company.companyname+'-'+type"></download>
      </div>
      <div class="table-responsive mt15" v-dragscroll="true">
        <table class="table fonts11 w50" :id="company.companyname+'-'+type">
          <thead>
            <tr>
              <th>Date</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(d, ind) in comPriceData" :key="'d'+ind">
              <td>{{compPriceLables[ind]}}</td>
              <td>{{d}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <!-- </card> -->
</template>
<script>
import { commonMixins } from "../../../assets/mixins/common.js";

export default {
  props: ["graphData", "company", "type"],
  mixins: [commonMixins],
  created() {
    // this.getCompaniesList();
  },
  methods: {
    getDurationData(ind) {
      this.duration[this.selDur].active = 0;
      this.duration[ind].active = 1;
      this.selDur = ind;
      var durDate = new Date();
      var curDate = new Date();
      durDate = this.minusMonths(
        new Date(curDate.getFullYear(), curDate.getMonth(), "01"),
        this.duration[ind].duration
      );
      console.log("durDate", durDate, curDate);
      this.getDataForDuration(curDate, durDate);
    },
    getDataForDuration(curDate, durDate) {
      (this.comPriceData = []), (this.compPriceLables = []);
      this.companyPrices.forEach((val, key) => {
        var ddate = new Date(val.date);
        console.log(val, ddate, ddate > durDate, durDate);
        if (ddate > durDate) {
          this.compPriceLables.push(this.getDate(val.date));
          this.comPriceData.push(val.Volume);
        }
      });
      console.log(
        "this.comPriceData",
        this.compPriceLables.length
      );
      // this.comPriceData = this.getDataInRatio(this.comPriceData);
      console.log("this.comPriceData", this.comPriceData, this.compPriceLables);
      // this.plotGraph();
      this.configureChart();
    },
    plotGraph() {
      console.log("Plot Graph", this.compData, this.compData.co_code);
      if (this.compData.co_code != "") {
        setTimeout(() => {
          this.configureChart();
        });
      }
    },
    configureChart() {
      console.log("Configure Graph");
      this.graphOptions["plugins"] = {
        datalabels: {
          display: false,
          align: "top",
          anchor: "end"
        }
      };
      // var ctx = document.getElementById("comprice").getContext("2d");
      var comPriceChartContent = document.getElementById(
        this.type+"comPriceChartContent"
      );
      comPriceChartContent.innerHTML = "&nbsp;";
      $("#"+this.type+"comPriceChartContent").append('<canvas id="'+this.type+'comprice"><canvas>');

      var ctx = $("#"+this.type+"comprice")
        .get(0)
        .getContext("2d");
      var chart = new Chart(ctx, {
        // The type of chart we want to create
        type: "line",
        // The data for our dataset
        data: {
          labels: this.compPriceLables,
          datasets: [
            {
              label: this.compData.companyname,
              backgroundColor: "transparent",
              borderColor: "rgb(227, 175, 100)",
              pointBackgroundColor: "#ffffff",
              data: this.comPriceData
            }
          ]
        },
        // Configuration options go here
        options: this.graphOptions
      });
      chart.update();
    }
  },
  data() {
    return {
      graphOptions: {
        maintainAspectRatio: true,
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              display: true,
              gridLines: {
                display: false
              }
            }
          ],
          yAxes: [
            {
              // ticks: {
              //   beginAtZero: true
              // },
              display: true,
              gridLines: {
                zeroLineColor: "#e8e9ef",
                color: "#e8e9ef",
                drawBorder: true
              }
            }
          ]
        },
        elements: {
          line: {
            tension: 0.00001,
            borderWidth: 1
          },
          point: {
            radius: 1,
            hitRadius: 10,
            hoverRadius: 1,
            borderWidth: 2
          }
        }
      },
      companyPrices: [],
      comPriceData: [],
      compPriceLables: [],
      isChartdataLoading: 0,
      duration: [
        { id: "1m", name: "1M", active: 0, duration: 0 },
        { id: "3m", name: "3M", active: 0, duration: 3 },
        { id: "6m", name: "6M", active: 0, duration: 6 },
        { id: "1y", name: "1Y", active: 0, duration: 12 },
        { id: "3Y", name: "3Y", active: 0, duration: 36 },
        { id: "5Y", name: "5Y", active: 0, duration: 60 },
        { id: "10Y", name: "10Y", active: 1, duration: 120 }
      ],
      selDur: 6,
      compData: {co_code: '', companyname: ''}
    };
  },
  watch: {
    company: function(value){
      console.log("Company Data", value);
      this.compData = value;
    },
    graphData: function(value) {
      console.log("Raw Data changed", value);
      // this._chart.destroy();
      this.comPriceData = [],
      this.compPriceLables = [];
      this.companyPrices = value.data;
      this.compData = value.company;
      this.companyPrices.forEach((val, key) => {
        // console.log(key, val);
        this.compPriceLables.push(this.getDate(val.date));
        this.comPriceData.push(val.Volume);
      });
      // this.comPriceData = this.getDataInRatio(this.comPriceData);
      console.log(
        "this.comPriceData",
        this.comPriceData.length,
        // this.compPriceLables
      );
      this.plotGraph();
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/company/company-price-graph/volumeGraph.vue